import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { GetJobsResponse } from '../../../../shared/types/routes/jobs';

const DEFAULT_REFETCH_JOBS_INTERVAL = 5000;

/**
 * Get a list of jobs by their tokens.
 */
function getJobsByTokens(jobTokens: string[]) {
  return get<GetJobsResponse>(`/api/jobs/status`, true, { jobs: jobTokens });
}

//  Ensures that the query key is unique for each set of job tokens.
const getQueryKey = (jobTokens: string[]): QueryKey => ['jobs', jobTokens];

/**
 * Polls for a list of jobs by their tokens.
 */
export default function usePollJobs(jobTokens: string[], shouldFetch: boolean = false) {
  return useQuery<GetJobsResponse>({
    queryFn: () => getJobsByTokens(jobTokens),
    queryKey: getQueryKey(jobTokens),
    //  Poll for job status updates every 5 seconds.
    refetchInterval: DEFAULT_REFETCH_JOBS_INTERVAL,
    //  This allows us to "turn off" the polling when there are no jobs in the queue to poll for.
    enabled: shouldFetch,
  });
}
